export const NO_OP = () => {};

export const withTracking =
  <T, R = void>(f: (...args: T[]) => R, event: string, properties?: ((...args: T[]) => Object) | Object) =>
  (...args: T[]) => {
    const res = f(...args);

    try {
      const p = properties ? (typeof properties === 'function' ? properties(...args) : properties) : undefined;
      analytics.track(event.toString(), p);
    } catch (e) {}

    return res;
  };

export const track = (event: string, properties: Object = {}) => {
  try {
    analytics.track(event.toString(), properties);
  } catch (e) {}
};
